module.exports = __webpack_public_path__ + "img/alldata.416273ee.jpg";